import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/favorites").then((r) => setItems(r.data.favorites || [])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try { await api.delete(`/favorites/${id}`); setItems((xs) => xs.filter((x) => x.id !== id)); toast.success("removed"); } catch { toast.error("could not remove"); }
  };

  return (
    <div className="min-h-[80vh] max-w-3xl mx-auto px-6 py-16" data-testid="favorites-page">
      <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: "var(--gold)" }}>your collection</p>
      <h1 className="font-serif text-4xl sm:text-5xl mb-10" style={{ color: "var(--ink)" }}>lines i loved.</h1>
      {loading ? (
        <p style={{ color: "var(--ink-soft)" }}>loading…</p>
      ) : items.length === 0 ? (
        <div className="border-t pt-8" style={{ borderColor: "var(--gold-soft)" }}>
          <p className="mb-4" style={{ color: "var(--ink-soft)" }}>
            no saved lines yet. while you read, highlight any sentence and hit &ldquo;save this line&rdquo; to keep it here.
          </p>
          <Link to="/course" className="btn-primary" data-testid="favorites-open-course">open the course</Link>
        </div>
      ) : (
        <ul className="space-y-6" data-testid="favorites-list">
          {items.map((f) => (
            <li key={f.id} className="border-l-2 pl-6 py-2 relative" style={{ borderColor: "var(--gold)" }}>
              <p className="font-serif text-xl leading-snug mb-2" style={{ color: "var(--ink)" }}>&ldquo;{f.text}&rdquo;</p>
              <p className="text-xs uppercase tracking-widest" style={{ color: "var(--ink-soft)" }}>
                from {f.lesson_title}
              </p>
              <button
                onClick={() => remove(f.id)}
                className="absolute top-2 right-0 opacity-40 hover:opacity-100"
                data-testid={`fav-delete-${f.id}`}
                title="remove"
              >
                <Trash2 size={14} strokeWidth={1.5} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
